import React from 'react'
import { observer } from 'mobx-react'
import FileButton from 'components/FileButton'
import Button from 'components/Button'
import CreateOCRScopeJobsViewModel, {
  ACCEPTED_OCR_FILE_TYPES,
} from '../../views/CreateOCRScopeJobsDialog/CreateOCRScopeJobsViewModel'

interface OCRScopeNewJobButtonProps {
  vm: CreateOCRScopeJobsViewModel
  wideSlimButton?: boolean
}

export default observer(function OCRScopeNewJobButton({
  vm,
  wideSlimButton = false,
}: OCRScopeNewJobButtonProps) {
  return (
    <FileButton
      stretchButton={wideSlimButton}
      multiple
      onChange={vm.addFiles}
      accept={ACCEPTED_OCR_FILE_TYPES}
    >
      <Button
        size={wideSlimButton ? 'wide-slim' : 'normal'}
        type="primary"
        onClick={() => vm.open()}
      >
        Scope New Job
      </Button>
    </FileButton>
  )
})
